'use client'

import { ErrorBoundary } from 'components/ErrorBoundary'
import { Provider } from 'jotai'
import { MotionConfig } from 'motion/react'
import { ReactNode } from 'react'
import { Provider as BusProvider } from 'react-bus'

import { LazyToastContainer } from '@/components/LazyToastContainer'
import { getStore } from '@/store'

import { LazyUseResetGeneratorForms } from './LazyUseResetGeneratorForms'
import { UseInitializeLazyAtoms } from './UseInitializeLazyAtoms'
import { UsePostHog } from './UsePostHog'
import { UseSetUpHasNavigatedState } from './UseSetUpHasNavigatedState'
import { UseStatsig } from './UseStatsig'

export const RootProviders = ({ children }: { children: ReactNode }) => {
	return (
		<MotionConfig transition={{ duration: 0.2, ease: 'easeInOut' }}>
			<BusProvider>
				<Provider store={getStore()}>
					<UseInitializeLazyAtoms />
					<UseSetUpHasNavigatedState />
					<UsePostHog />
					<UseStatsig />
					<LazyUseResetGeneratorForms />
					<ErrorBoundary>{children}</ErrorBoundary>
					<LazyToastContainer containerId="notification" />
				</Provider>
			</BusProvider>
		</MotionConfig>
	)
}
